import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { deleteEntity, updateEntities } from 'redux-modules/entity'
import api from 'api'

const CREATE_REQUEST = 'realhub/publicationOptionValue/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/publicationOptionValue/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/publicationOptionValue/CREATE_FAILURE'
const UPDATE_REQUEST = 'realhub/publicationOptionValue/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/publicationOptionValue/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/publicationOptionValue/UPDATE_FAILURE'
const DELETE_REQUEST = 'realhub/publicationOptionValue/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/publicationOptionValue/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/publicationOptionValue/DELETE_FAILURE'

// Initial State
const initialState = {
  result: [],
  creating: false,
  deleting: false,
  errors: [],
}

// Actions
export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(payload = {}){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(payload = {}){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function deletePublicationOptionValue(optionValue, options){
  const config = {
    method: 'DELETE',
  }
  return (dispatch, getState) => {
    // Set Loading
    dispatch(deleteRequest())
    const url = `/admin/publications/${optionValue.publication_id}/options/${optionValue.publication_option_id}/values/${optionValue.id}.json`
    const promise = api(url, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }
        const state = getState()

        // Remove the option value to the result array
        const publicationOptionValueArray = state.publicationOptionValues.result ? state.publicationOptionValues.result.slice() : []
        const index = publicationOptionValueArray.indexOf(optionValue.id)
        const x = normalize(optionValue, Schemas.PUBLICATION_OPTION_VALUE)
        dispatch(deleteEntity(x))

        // Remove the entity
        if (index != -1){
          publicationOptionValueArray.splice(index, 1)
          dispatch(deleteSuccess({ result: publicationOptionValueArray }))
        }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(errors))
      })
    return promise
  }
}

export function updatePublicationOptionValue(params, options){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      publication_option_value: params,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/publications/${params.publication_id}/options/${params.publication_option_id}/values/${params.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }
        const normalizedJson = normalize(json, Schemas.PUBLICATION_OPTION_VALUE)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

export function createPublicationOptionValue(optionValue, options){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      publication_option_value: optionValue,
    }),
  }

  return (dispatch, getState) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api(`/admin/publications/${optionValue.publication_id}/options/${optionValue.publication_option_id}/values.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Add to result array
        const resultArray = getState().publicationOptionValues.result ? getState().publicationOptionValues.result.slice() : []
        if (!resultArray.includes(json.id)){
          resultArray.push(json.id)
        }

        const normalizedJson = normalize(json, Schemas.PUBLICATION_OPTION_VALUE)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess({ result: resultArray }))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true,
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        result: action.result,
        errors: [],
      })
    case CREATE_FAILURE:
      return Object.assign({}, state, {
        creating: false,
        errors: action.errors,
      })
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true,
      })
    case UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        errors: [],
      })
    case UPDATE_FAILURE:
      return Object.assign({}, state, {
        updating: false,
        errors: action.errors,
      })
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        deleting: true,
      })
    case DELETE_SUCCESS:
      return Object.assign({}, state, {
        deleting: false,
        result: action.result,
        errors: [],
      })
    case DELETE_FAILURE:
      return Object.assign({}, state, {
        deleting: false,
        errors: action.errors,
      })
    default:
      return state
  }
}
